export default __webpack_public_path__ + "static/media/2026_banner_6.b03459dc.png";